import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-committees',
  templateUrl: './admin-committees.component.html',
  styleUrls: ['./admin-committees.component.css']
})
export class AdminCommitteesComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  committees: any[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddcommittee = false;
  result = '';
  subscriptions: Subscription[] = [];
  value: any;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'abbreviation', header: 'Förkortning' },
      { field: 'name', header: 'Kommittenamn' },
      { field: 'sort', header: 'Sortering' }
    ];
    this.getCommittees();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getCommittees() {
    this.adminService.GetCommittees().subscribe(data => {
      if (data) {
        this.committees = data;
      }
    });
  }

  saveCommittee(evt) {
    this.adminService.UpdateCommittee(evt).subscribe(x => {
      this.display = false;
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Utskott uppdaterat' });
      this.getCommittees();
    });
  }

  saveAddCommittee(evt) {
    this.adminService.AddCommittee(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Utskott tillagt.' });
        this.getCommittees();
      }
    });
    this.displayaddcommittee = false;
  }

  cancelEdit() {
    this.display = false;
  }

  cancelAdd() {
    this.displayaddcommittee = false;
  }
  addCommittee() {
    this.displayaddcommittee = true;
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera valt utskott?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteCommittee(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteCommittee(rowdata) {
    this.adminService.RemoveCommittee(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Utskott raderad.' });
        this.getCommittees();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  exportToCSV() {
    let firstrow = '';
    this.cols.forEach(c => {
      firstrow += c.header + ';';
    });
    const filnamn = 'OF_committees';
    const excelrecords: any[] = [];
    this.committees.forEach(r => {
      const row = {
        abbreviation: r.abbreviation,
        name: r.name,
        sort: r.sort
      }
      excelrecords.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);

  }
}
